import Pagination from '@/_application/core/components/ui/pagination';
import {scrollToElementById} from '@/_application/core/utils/scroll-to-element-by-id';
import React from 'react';
import {useProductListView} from '@/_application/modules/products/provider/product-list-view.provider';
import {ProductBlockEnum} from '@/_application/modules/products/model/product-block.enum';
interface IProps {
    totalItems: number;
    pageSize: number;
    handlePaginationChange: (value: number) => void;
}

function CategoryProductsPagination({pageSize, totalItems, handlePaginationChange}: Readonly<IProps>) {
    const {currentPage} = useProductListView();

    const handlePagination = (value: number) => {
        scrollToElementById(ProductBlockEnum.PRODUCT_CATEGORY_BLOCK, -140);
        handlePaginationChange(value);
    };

    return (
        <div className="mt-5 flex items-center justify-center">
            <Pagination
                total={totalItems}
                current={currentPage}
                pageSize={pageSize}
                onChange={handlePagination}
                showTitle={false}
            />
        </div>
    );
}

export default CategoryProductsPagination;
